import type { FaireProductEntity } from "../../entity_types/product";

export const p_3bxp60cp75: FaireProductEntity = {
  token: "p_3bxp60cp75",
  type: "product",
  name: "LEOPARD PRINT CORDUROY SKATER DRESS",
  brandToken: "b_zhk3ege2r2",
  brandName: "SM WARDROBE",
  imageUrl:
    "https://cdn.faire.com/fastly/d87413e9580cb8fed5d0ac20b39f66e9364867ffa479a5a05027688e9ebd1240.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd96f58015a4411e1b68252f8685245c2adea36b9c550d4fb494766807ccc3d0.jpeg",
    "https://cdn.faire.com/fastly/d6b5b90bd15021f8b1e0dac6abf649f8a83c415c983e4ed3efbcd47df75f4a51.jpeg",
  ],
  priceDollars: 41.94,
  description:
    "Introducing the Leopard Print Corduroy Dress Grey from SM Wardrobe, an embodiment of casual aesthetics and contemporary fit. This piece is perfect for everyday wear, especially in the fall/winter season. Crafted from 100% polyester, it features a unique leopard print and comes with the added convenience of pockets. Care is simple, just pop it into the machine for a wash. Revel in the New York City trends with this exquisite addition to your wardrobe.",
  tags: [],
  msrpDollars: 83.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:45.687Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
